import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Paper, } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import { IoIosSearch } from "react-icons/io";
import {
    Stack,
    Pagination,
} from "@mui/material";
import { token, APIPath } from "../../config/api";
import CountryForm from "./CountryForm";
import { LuCaseUpper } from "react-icons/lu";


const StyledTableContainer = styled(TableContainer)(({ theme, open }) => ({
    marginTop: "1%",
    marginLeft: open ? theme.spacing(29) : theme.spacing(7),
    width: open ? "80%" : "94%",
    height: "100vh",
    transition: "margin-left 0.3s ease",
    background: "rgba(204,204,204,0.2)",
    padding: "1rem 1rem 1rem 1rem",
    boxShadow: "none",
}));
const StyledPaginationContainer = styled("div")({
    background: "#fff",
    margin: "2rem auto 0 auto;",
    zIndex: 1,
    background: "none",
    display: "flex",
    justifyContent: "center"
});

const CountryList = ({ open }) => {
    const [newCountry, setnewCountry] = useState(false);
    const [countryList, setCountryList] = useState(null);
    const [searchText, setsearchText] = React.useState('');
    const [isLoading, setIsLoading] = useState(false);

    const CountrylName = () => {
        setIsLoading(true);
        fetch(`${APIPath}/api/v1/agency/country`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            method: 'GET',
            mode: 'cors',
        })
            .then((res) => res.json())
            .then((data) => {
                console.log(data);
                setCountryList(data.data)
                setIsLoading(false);
                onClose();
            })
            .catch((err) => {
                alert(err)
                setIsLoading(false)
            })
    }
    useEffect(() => {
        CountrylName();
    }, [])
    const filterdata =countryList && countryList?.filter(item =>
        item.name.toLowerCase().includes(searchText.toLowerCase())
    );
    const onClose = () => {
        setnewCountry(false);
    }
    const onShow = () => {
        setnewCountry(true)
    }

    const deleteCountry=(id)=>{
        let confirm=window.confirm("Are you sure you want to delete this Country? This action cannot be undone");
        if(confirm){
            setIsLoading(true);
            fetch(`${APIPath}/api/v1/agency/country?id=${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                method: 'DELETE',
                mode: 'cors',
            })
                .then((res) => res.json())
                .then((data) => {
                    alert("Country deleted");
                    setIsLoading(false);
                    CountrylName();
                })
                .catch((err) => {
                    alert(err)
                    setIsLoading(false)
                })
        }
        else {
            setIsLoading(false);
            return
        }

    }
    const Uppercase = (str) => str.toUpperCase();

    return (
        <>
            <StyledTableContainer component={Paper} open={open}>
                <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 20px" }}>
                    <h2 style={{ fontSize: "18px" }}>Country</h2>
                    <button className="add-hotel"
                        onClick={onShow}
                    >Add Country</button>
                </div>
                <div className="package-search-table" style={{ paddingBottom: "2rem" }}>
                    <div className="package-search">
                        <input type="text" placeholder="Search.."
                            value={searchText} onChange={(e) => {
                                setsearchText(e.target.value)
                            }}
                        />
                        <IoIosSearch style={{ cursor: "pointer", color: "skyblue" }} />
                    </div>
                    <div className="package-table" style={{
                        // width: "fit-content",
                        // marginLeft: "1rem",
                        // border: "1px solid #dedede",
                        // boxShadow: "0 0 100px #dedede",
                        borderBottomRightRadius: "20px",
                        borderBottomLeftRadius: "20px",
                    }}>
                        <table>
                            <thead>
                                <tr>
                                    <th>Sl No. </th>
                                    <th>Country </th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {isLoading ? <div className="loader"></div> :
                                <>
                                    <tbody>
                                        {filterdata?.map((country, id) => {
                                            return <>
                                                <tr key={id}>
                                                    <td>{id + 1}</td>
                                                    <td>{Uppercase(country.name)}</td>
                                                    <td> <button id="country-delete" 
                                                    onClick={()=>{
                                                        deleteCountry(country._id);
                                                    }}
                                                    >
                                                        <img src="./deleteicon.svg" />
                                                    </button>
                                                    </td>
                                                </tr>
                                            </>
                                        })}
                                    </tbody>
                                </>}
                        </table>
                    </div>
                </div>
                {/* <StyledPaginationContainer>
                    <Stack spacing={1}>
                        <Pagination
                            count={Math.ceil((vehicleList && vehicleList?.length) / perPage)}
                            // count={1}
                            page={currentPage}
                            onChange={(event, value) => setCurrentPage(value)}
                            variant="outlined"
                            color="primary"
                            boundaryCount={1}
                        />
                    </Stack>
                </StyledPaginationContainer> */}
            </StyledTableContainer>
            {newCountry && <CountryForm onClose={onClose} onShow={onShow} CountrylName={CountrylName} />}
        </>
    );
}

export default CountryList;
